import { RemovableRef, StorageSerializers, useLocalStorage } from '@vueuse/core'
import { defineStore } from 'pinia'

const CONSENT_STORAGE_KEY = 'cookiefirst-consent'

interface ConsentData {
  necessary: boolean
  performance: boolean
  functional: boolean
  advertising: boolean
  timestamp: number | null
  type: string | null
  version: string | null
}

interface ConsentState {
  consent: RemovableRef<ConsentData | null>
}

export const useConsentStore = defineStore('consent', {
  state: (): ConsentState => ({
    consent: useLocalStorage(CONSENT_STORAGE_KEY, null, {
      serializer: StorageSerializers.object
    })
  }),

  getters: {
    getConsent: (state): ConsentData | null => state.consent,

    isNecessaryAccepted: (state): boolean => state.consent?.necessary ?? false,

    isPerformanceAccepted: (state): boolean =>
      state.consent?.performance ?? false,

    isFunctionalAccepted: (state): boolean =>
      state.consent?.functional ?? false,

    isAdvertisingAccepted: (state): boolean =>
      state.consent?.advertising ?? false,

    getTimestamp: (state): number | null => state.consent?.timestamp ?? null,

    getType: (state): string | null => state.consent?.type ?? null,

    getVersion: (state): string | null => state.consent?.version ?? null,

    hasAnyConsent: (state): boolean =>
      state.consent?.performance ||
      state.consent?.functional ||
      state.consent?.advertising ||
      false,

    isAllAccepted: (state): boolean =>
      (state.consent?.necessary &&
        state.consent?.performance &&
        state.consent?.functional &&
        state.consent?.advertising) ||
      false
  },
  actions: {
    initializeConsentListeners() {
      window.addEventListener('cf_consent', this.updateConsent)
    },
    updateConsent() {
      this.consent = JSON.parse(
        localStorage.getItem(CONSENT_STORAGE_KEY) || 'null'
      )
    }
  }
})
